import { KyRequest, KyResponse, Options } from 'ky';

import { delay } from '.';

export type RetryOptions = Options & { retryCount?: number };

export type RetryHookOptions<RefreshResponse = unknown> = {
  retry: (
    request: KyRequest,
    options: RetryOptions,
  ) => Promise<void | Response>;
  refreshToken: (request: KyRequest) => Promise<RefreshResponse>;
};

export const setAuthToken =
  (getToken: (request: KyRequest) => Promise<string | null | undefined>) =>
  async (request: KyRequest) => {
    const token = await getToken(request);
    if (!token) return;
    request.headers.set('Authorization', `Bearer ${token}`);
  };

export const retryRequest =
  <RefreshResponse>({
    retry,
    refreshToken,
  }: RetryHookOptions<RefreshResponse>) =>
  async (
    request: KyRequest,
    options: Options & { retryCount?: number },
    response: KyResponse,
  ) => {
    if (response.status === 401) {
      const retryCount = options.retryCount ?? 0;

      if (retryCount >= 3) {
        // window.location.href = window.location.origin;
        throw new Error('number of attempts exceeded');
      }

      options.retryCount = retryCount + 1;

      delay(1500);
      await refreshToken(request);
      return await retry(request, options);
    }

    return response;
  };
